<template>
    <div id="system-setting">
        <router-view />
    </div>
</template>

<script>
// import UrlApi from "@/utils/UrlApi.js";
export default {
    name:"systemSetting",
    data () {
        return {
            
        };
    },
    methods: {

    }
}

</script>
<style lang="less" scoped>
    #system-setting {
        width: 100%;
        margin: 0 auto;
        min-height: calc(100vh - 145px);
    }
</style>